import { createContext } from "react";
import { type NotifyProps } from "./NotificationsProvider";

export type NotificationContextType = {
  notify: (props: NotifyProps) => void;
};

export const NotificationContext = createContext<
  NotificationContextType | undefined
>(undefined);
